module.exports = __webpack_public_path__ + "assets/AMS.png";


//////////////////
// WEBPACK FOOTER
// ./libs/images/AMS.png
// module id = 344
// module chunks = 0